import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import NOB from '../../../../constants/language-strings';
import { SIGN_OUT_PATH } from '../../../../constants/paths';
import { PurPurButton } from 'components';
export const EndDayButton = ({ endDayFunction }) => {
    const navigate = useNavigate();
    const endDayAndSignOut = () => {
        endDayFunction(true);
        navigate(SIGN_OUT_PATH);
    };
    return (_jsx(PurPurButton, { variant: 'secondary', onClick: endDayAndSignOut, fullWidth: true, children: NOB.END_DAY.END_DAY }));
};
